import { isRetail } from "./Utils"

const useRetail = isRetail();

var PENDING = 0;
var FULFILLED = 1;
var REJECTED = 2;

function Promise () {
	this._thens = [];
}

Promise.prototype = {
	then: function (onResolve, onReject) 
	{
		this._thens.push({ resolve: onResolve, reject: onReject });
	},

	resolve: function (val) { this._complete('resolve', val); },
	reject: function (ex) { this._complete('reject', ex); },

	_complete: function (which, arg) 
	{
		this.then = which === 'resolve' ?
			function (resolve, reject) { resolve && resolve(arg); } :
			function (resolve, reject) { reject && reject(arg); };

		this.resolve = this.reject = 
			function () { throw new Error('Promise already completed.'); };

		var aThen, i = 0;
		while (aThen = this._thens[i++]) { aThen[which] && aThen[which](arg); }
		delete this._thens;
	}
};

if( typeof window.LSLoyalty === 'undefined' )
{
	window.LSLoyalty = {}
	window.LSLoyalty.nextMessageId = 0;
	window.LSLoyalty.requestPromises = {};
	window.LSLoyalty.nativeToScriptRequestSucceededCallback = (requestId, response) =>
	{
		if( typeof window.LSLoyalty.requestPromises[requestId] !== 'undefined' )
		{
			window.LSLoyalty.requestPromises[requestId].resolve(response);
		}
	}

	window.LSLoyalty.nativeToScriptRequestFailedCallback = (requestId, errorMessage) =>
	{
		if( typeof window.LSLoyalty.requestPromises[requestId] !== 'undefined' )
		{
			window.LSLoyalty.requestPromises[requestId].reject(errorMessage);
		}
	}
}

function addPromiseToQueue(p)
{
	window.LSLoyalty.requestPromises[window.LSLoyalty.nextMessageId] = p;

	return window.LSLoyalty.nextMessageId++
}

function executeRestoCall(funcName, paramObj)
{
	if( typeof window.webkit === 'undefined' || typeof window.webkit.messageHandlers ==='undefined' || typeof window.webkit.messageHandlers[funcName] === 'undefined' ) return;
	
	window.webkit.messageHandlers[funcName].postMessage(paramObj);
}

export function addPayment(name, amount, transactionId, userId, hash, type)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	executeRestoCall("addPayment", {messageId, amount, name, transactionId, userId, hash, type});

	return p;
}

export function addRewardRedemption(name, discount, transactionId, userId, hash, type)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	executeRestoCall("addRewardRedemption", {messageId, discount, name, transactionId, userId, hash, type});

	return p;
}

export function addCheckIn(name, userId, hash, type)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	console.log("{messageId, name, userId, hash, type}",{messageId, name, userId, hash, type})
	executeRestoCall("addCheckIn", {messageId, name, userId, hash, type});

	return p;
}

export function voidPayment(uuid)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	executeRestoCall("voidPayment", {messageId, uuid});

	return p;
}

export function getReceipt()
{
	if( useRetail )
	{
		var p = new Promise();
		setTimeout(()=>
		{
			p.resolve({totalDue:"13.25", receiptItems:"[]", payments:"[]"})
		})

		return p;
	}

	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	executeRestoCall("retrieveReceipt", {messageId});

	return p;
}

export function getCredentials()
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	executeRestoCall("retrieveCredentials", {messageId});

	return p;
}

export function getTotalAmountOutstanding()
{
	var p = new Promise();
		executeRestoCall("retrieveReceipt", {});
	if( typeof window.LSLoyalty !== 'undefined' )
	{
		setTimeout(function()
		{
			p.resolve((6).toFixed(2));
		},500);	
		// window.LSLoyalty.getReceipt((a)=>
		// {
		// 	p.resolve(1);
		// }, (a)=>
		// {
		// 	p.resolve(2);
		// })		
	}
	else
	{
		setTimeout(function()
		{
			p.resolve(window.invoiceTotal.toFixed(2));
		},500);		
	}

	return p;
}

export function retrieveUserDetails()
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	executeRestoCall("retrieveUserDetails", {messageId});

	return p;
}

export function setPageTitles(back, title, right)
{
	var p = new Promise();
	executeRestoCall("setPageTitles", {back, title, right});

	return p;
}

export function close(urlInputs)
{
	if( useRetail ) window.location.href = urlInputs.returnURL;
	else executeRestoCall("close", {});
}

export function reUpRPCCall(body)
{
	var p = new Promise();
	var messageId = addPromiseToQueue(p);
	executeRestoCall("reUpRPCCall", {messageId, body});

	return p;
}

export function backToScan()
{
	executeRestoCall("backToScan", {});
}
